import { post } from '@/services/awsAmplify'

export interface IRewardDTO {
  usernames: string
  contestId?: string
  postMessage?: string
  activityMessage: string
  reward: number
  publishPost: boolean
}

export type OpenAppRewardData = {
  day?: number
  of?: number
}

export const createCustomRewards = async (
  customRewards: IRewardDTO
): Promise<IRewardDTO> => {
  if (!customRewards.publishPost) {
    delete customRewards.contestId
    delete customRewards.postMessage
  }
  return post({
    path: `/rewards`,
    params: {
      ...customRewards,
    },
  }) as unknown as IRewardDTO
}

export const createOpenAppReward = async (
  accountId: string
): Promise<OpenAppRewardData> => {
  return post({
    path: `/reward-open-app/${accountId}`,
  }) as unknown as OpenAppRewardData
}
